import { useTranslation } from 'react-i18next';
import { GoogleFontIcon, Switch, Tooltip } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useStakeAdjustmentStore } from '../../store/states/stakeAdjustment';

import styles from './stakeAdjustmentToggle.module.scss';

type StakeAdjustmentToggleProps = {
  filterKey: string;
  defaultEnabled: boolean;
};

export function StakeAdjustmentToggle({
  filterKey,
  defaultEnabled,
}: StakeAdjustmentToggleProps) {
  const { t } = useTranslation();
  const [stakeAdjusted, setStakeAdjusted] = useStakeAdjustmentStore(
    useShallow((state) => [
      state.stakeAdjusted[filterKey],
      state.setStakeAdjusted,
    ])
  );

  return (
    <div className={styles['root']}>
      <Switch
        label={t('app.stakeAdjustment.label')}
        checked={stakeAdjusted ?? defaultEnabled}
        onChange={(checked) => setStakeAdjusted(filterKey, checked)}
      />
      <Tooltip label={t('app.stakeAdjustment.tooltip')} usePortal={true}>
        <GoogleFontIcon name="info" />
      </Tooltip>
    </div>
  );
}
